import _ from "lodash";

export default host => (_.isNil(host) ? "" : host
  .replace(/https:\/\//g, "")
  .replace(/http:\/\//g, "")
  .replace(/\./g, "")
  .replace(/\//g, ""));
